import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { DiscoverRouteNames, DiscoverRoutePathNames } from '../../enums';
import { beforeEnter } from '../guards';

const Component = () => import('./DiscoverList.vue');

export default {
  path: buildChildURL(DiscoverRoutePathNames.LIST),
  name: DiscoverRouteNames.DISCOVER_LIST,
  component: Component,
  beforeEnter,
} as RouteRecordRaw;
